import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { randomStr } from '../../utils/randomStr';
import Button from '../Button/Button';
import brand from '../../assets/images/grainger-logo.png';
import brandWhite from '../../assets/images/grainger-logo-white.png';

import './Navigation.scss';

export default class Navigation extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isMenuClosed: true
    };

    this.handleToggleMenu = this.handleToggleMenu.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keyup', (e) => {
      if (e.defaultPrevented || this.state.isMenuClosed) {
        return;
      }

      const KEY = e.key || e.keyCode;

      if (KEY === 'Escape' || KEY === 'Esc' || KEY === 27) {
        this.handleToggleMenu();
      }
    });
  }

  handleToggleMenu() {
    this.setState({
      isMenuClosed: !this.state.isMenuClosed
    });
  }

  render() {
    return (
      <div className="navigation">
        <div className="navigation__wrap">
          <img className="navigation__brand" src={brand} alt="grainger plc logo" />
          <Button className="navigation__documents" onClick={this.handleToggleMenu}>
            Documents
          </Button>

          <nav className={`navigation__sidebar-burger-menu ${!this.state.isMenuClosed ? 'navigation__sidebar-burger-menu--active' : ''}`}>
            <div style={{position :  'relative', height: '100%', paddingBottom: '70px'}} className="container">
              <div className="navigation__burger-menu-header">
                <img className="navigation__burger-menu-brand" src={brandWhite} alt="grainger plc logo"/>
                <button className="navigation__burger-menu-close" onClick={this.handleToggleMenu}>
                  <span className="sr-only">Close navigation menu</span>
                  <i className="leasing-icon leasing-icon-close-nav" aria-hidden="true"/>
                </button>
              </div>

              <ul className="navigation__sidebar-burger-menu-list">
                {this.props.navLinks.map((link, index) => (
                  <li className="navigation__sidebar-burger-menu-items" style={{transitionDelay: `${index * .05}s`}} key={randomStr(link.text)}>
                    <a href={link.url} className="navigation__sidebar-burger-menu-text" target="_bland">
                      {link.text}
                      <span className="sr-only">Opens document in new window</span>
                    </a>
                  </li>
                ))}
              </ul>

              <div className="navigation__burger-menu-footer">
                <ul className="list navigation__footer__social-links">
                  <li className="navigation__footer__social-links-item">
                    <a
                      className="navigation__footer__social-link"
                      href="https://www.facebook.com/Graingerplc/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Grainger's Facebook page"
                    >
                      <span className="sr-only">Link to Grainger's facebook</span>
                      <i className="icon icon-facebook" aria-hidden="true"/>
                    </a>
                  </li>
                  <li className="navigation__footer__social-links-item">
                    <a
                      className="navigation__footer__social-link"
                      href="https://twitter.com/graingerplc"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Grainger's Twitter page"
                    >
                      <span className="sr-only">Link to Grainger's twitter</span>
                      <i className="icon icon-twitter" aria-hidden="true"/>
                    </a>
                  </li>
                  <li className="navigation__footer__social-links-item">
                    <a
                      className="navigation__footer__social-link"
                      href="https://www.instagram.com/graingerplc"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Grainger's Instagram page"
                    >
                      <span className="sr-only">Link to Grainger's instagram</span>
                      <i className="icon icon-instagram" aria-hidden="true"/>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    );
  }
}

Navigation.propTypes = {
  navLinks: PropTypes.arrayOf(PropTypes.shape({
    link: PropTypes.string,
    text: PropTypes.text
  }))
}



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.jsx